import { situationCrimePreventionClassificationTableNL } from '../abstract';
import { messages } from './en';

export const messagesNL: typeof messages = {
  LANDING_CASES: { TITLE: 'Case management', DESC: 'Voer uw zaak in en vind de meest relevante misdaadscripts.' },
  LANDING_HAND: { TITLE: 'Samenwerken', DESC: 'Werk samen om misdaden op te lossen en te voorkomen.' },
  LANDING_SECURITY: {
    TITLE: 'Veiligheid voorop',
    DESC: 'Alle misdaadscripts worden opgeslagen in een lokaal bestand en gecached in uw browser. Geen wachtwoord vereist, geen informatiedeling met derden. Dit bestand dient u natuurlijk wel zelf veilig te beheeren.',
  },
  HOME: { TITLE: 'Home', ROUTE: '/home' },
  ABOUT: { TITLE: 'Gebruikte definities in PAX', ROUTE: '/over', TEXT: situationCrimePreventionClassificationTableNL },
  CRIME_SCRIPT: { TITLE: 'Crime script', ROUTE: '/crime_script' },
  SETTINGS: { TITLE: 'Instellingen', ROUTE: '/instellingen' },
  LANDING: { TITLE: 'Introductie', ROUTE: '/' },
  CASE: { TITLE: 'Casus', ROUTE: '/casus' },
  ARTICLE: { TITLE: 'Nieuws', ROUTE: '/nieuws' },
  USER: 'Gebruiker',
  EDITOR: 'Redacteur',
  ADMIN: 'Beheerder',
  CANCEL: 'Annuleren',
  DELETE: 'Verwijderen',
  YES: 'Ja',
  NO: 'Nee',
  OK: 'Ok',
  NAME: 'Naam',
  MISC: 'Overig',
  DESCRIPTION: 'Omschrijving',
  INFO: 'Info',
  DELETE_ITEM: {
    TITLE: '{item} verwijderen',
    DESCRIPTION: 'Weet je zeker dat je dit {item} wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
  },
  EDIT_BUTTON: {
    LABEL: 'Bewerken',
    TOOLTIP: 'Bewerken',
  },
  SAVE_BUTTON: {
    LABEL: 'Opslaan',
    TOOLTIP: 'Wijzigingen opslaan',
  },
  MODEL: 'Model',
  TITLE: 'Titel',
  AUTHORS: 'Auteurs',
  LINK: 'Link',
  TYPE: 'Type',
  SAVE_SCRIPT: 'Toon resultaat',
  EDIT_SCRIPT: 'Script bewerken',
  MERGE_SCRIPT: 'Script toevoegen',
  DELETE_SCRIPT: 'Script verwijderen',
  NEW_SCRIPT: 'Nieuw script',
  NEW_SCRIPT_NAME: 'Nieuw crime script',
  SAVE: 'Bewaar',
  EDIT: 'Bewerk',
  DELETE_SCRIPT_CONFIRM: 'Weet je zeker dat je het script "{name}" wilt verwijderen?',
  CAST_TYPE: 'Roltype',
  CAST: 'Rollen',
  CAST_DESC: `_Een rol kan een enkel individu, maar ook een groep, bedrijf of organisatie representeren, en omvat een samenhangend pakket van handelingen die door een of meer personen vervuld kan worden, zoals daders of guardians, maar ook derde partijen die het proces faciliteren, zoals corrupte ambtenaren en financiële instellingen waar geld wordt witgewassen._`,
  CONDITION: 'Gelegenheid',
  CONDITIONS: 'Gelegenheden',
  ATTRIBUTE: 'Attribuut',
  ATTRIBUTES: 'Attributen',
  ATTRIBUTE_DESC:
    "_Attributen zijn de 'rekwisieten' of 'props' die aangewend worden in de uitvoering van een crime script. Dit kunnen fysieke attributen zijn, zoals auto's of wapens, maar ook cognitieve attributen, zoals kennis of vaardigheden._",
  MEASURE: 'Barrière',
  MEASURES: 'Barrières',
  NEW_ACT: 'Nieuwe handeling',
  SUMMARY: 'Samenvatting',
  GOALS: 'Doel(en) van huidige scène',
  IMAGE: 'Afbeelding',
  ACTIVITY: 'Activiteit',
  ACTIVITIES: 'Activiteiten',
  SPECIFY: 'Specificeer eigenschappen',
  CATEGORY: 'Categorie',
  SELECT: 'Selecteren',
  CREATE: 'Maken',
  STAGES: 'Fasen',
  STAGE: 'Fase',
  TRACKS: 'Tracks',
  TRACK: 'Track',
  NO_TRACK: '-- geen track --',
  ADD_TRACK: 'Track toevoegen',
  EDIT_TRACK: 'Track bewerken',
  DEL_TRACK: 'Track verwijderen',
  SCENES: 'Scènes',
  SCENE: 'Scène',
  MAIN_ACTS: 'Hoofdscènes',
  ACTS: 'Activiteitengroepen',
  ACT: 'Activiteitengroep',
  REFERENCES: 'Referenties',
  DETAILS: 'Details',
  LANGUAGE: 'Taal',
  CLEAR: 'Wis model',
  UPLOAD: 'Lees model in als JSON',
  DOWNLOAD: 'Sla model op als JSON',
  PERMALINK: 'Maak permanente link',
  ROLE: 'Rol',
  ADD_ACT: 'Nieuwe activiteitengroep',
  DELETE_ACT: 'Verwijder activiteitengroep',
  DELETE_ACT_CONFIRM: 'Weet je zeker dat je de activiteitengroep "{name}" wilt verwijderen?',
  SELECT_ACT: 'Bewerk activiteitengroep',
  SELECT_ACT_N: 'Maak een nieuwe activiteitengroep aan of selecteer gelijkwaardige',

  /** Crime Prevention Techniques */
  INCREASE_EFFORT: 'Verhoog de inspanning',
  TREE_VIEW: { HIDE: 'Lijstweergave', SHOW: 'Boomweergave' },
  TARGET_HARDEN: {
    TITLE: 'Doelversteviging',
    DESC: 'Stuursloten en startonderbrekers, Anti-overval schermen, Manipulatiebestendige verpakking',
  },
  CONTROL_ACCESS: {
    TITLE: 'Controleer toegang tot faciliteiten',
    DESC: 'Deurtelefoons, Elektronische kaart toegang, Bagagecontrole',
  },
  SCREEN_EXITS: {
    TITLE: 'Controleer uitgangen',
    DESC: 'Ticket nodig voor vertrek, Exportdocumenten, Elektronische artikelbeveiliging',
  },
  DEFLECT_OFFENDERS: {
    TITLE: 'Leid overtreders af',
    DESC: 'Straatafsluitingen, Aparte toiletten voor vrouwen, Verspreid pubs',
  },
  CONTROL_TOOLS: {
    TITLE: 'Beheers gereedschappen/wapens',
    DESC: '"Slimme" wapens, Beperk verkoop spuitverf aan jongeren, Geharde bierglazen',
  },
  INCREASE_RISKS: "Verhoog de risico's",
  EXTEND_GUARDIANSHIP: {
    TITLE: 'Breid toezicht uit',
    DESC: "Ga 's nachts in groep uit, Laat tekenen van bewoning achter, Draag een mobiele telefoon",
  },
  ASSIST_SURVEILLANCE: {
    TITLE: 'Ondersteun natuurlijk toezicht',
    DESC: 'Verbeterde straatverlichting, Verdedigbaar ruimteontwerp, Ondersteuning van klokkenluiders',
  },
  REDUCE_ANONYMITY: {
    TITLE: 'Verminder anonimiteit',
    DESC: 'Taxichauffeur ID\'s, "Hoe is mijn rijgedrag?" stickers, Schooluniformen',
  },
  USE_PLACE_MANAGERS: {
    TITLE: 'Gebruik plaatsmanagers',
    DESC: 'CCTV voor dubbeldekkers, Twee bedienden voor gemakswinkels, Beloon waakzaamheid',
  },
  STRENGTHEN_SURVEILLANCE: {
    TITLE: 'Versterk formeel toezicht',
    DESC: "Roodlichtcamera's, Inbraakalarm, Beveiligingspersoneel",
  },
  REDUCE_REWARDS: 'Verminder de beloningen',
  CONCEAL_TARGETS: {
    TITLE: 'Verberg doelen',
    DESC: 'Parkeren buiten de straat, Genderneutrale telefoongidsen, Ongemarkeerde gepantserde vrachtwagens',
  },
  REMOVE_TARGETS: {
    TITLE: 'Verwijder doelen',
    DESC: 'Verwijderbare autoradio, Vrouwenopvang, Prepaidkaarten voor openbare telefoons',
  },
  IDENTIFY_PROPERTY: {
    TITLE: 'Identificeer eigendom',
    DESC: 'Eigendomsmarkering, Voertuigregistratie en onderdelenmarkering, Veemerken',
  },
  DISRUPT_MARKETS: {
    TITLE: 'Verstoor markten',
    DESC: 'Monitor pandjeshuis, Controles op rubrieksadvertenties, Vergunning voor straatverkopers',
  },
  DENY_BENEFITS: {
    TITLE: 'Ontzeg voordelen',
    DESC: 'Inktlabels op artikelen, Graffiti reiniging, Uitschakelen gestolen mobiele telefoons',
  },
  REDUCE_PROVOCATIONS: 'Verminder provocaties',
  REDUCE_FRUSTRATIONS: {
    TITLE: 'Verminder frustraties en stress',
    DESC: 'Efficiënte rijen, Beleefde service, Uitgebreide zitplaatsen, Rustgevende muziek/gedempte verlichting',
  },
  AVOID_DISPUTES: {
    TITLE: 'Vermijd geschillen',
    DESC: 'Gescheiden zitplaatsen voor rivaliserende voetbalfans, Verminder drukte in bars, Vaste taxitarieven',
  },
  REDUCE_TEMPTATION: {
    TITLE: 'Verminder verleiding en opwinding',
    DESC: 'Controles op gewelddadige pornografie, Handhaaf goed gedrag op voetbalveld, Verbied racistische opmerkingen',
  },
  NEUTRALIZE_PRESSURE: {
    TITLE: 'Neutraliseer groepsdruk',
    DESC: '"Idioten drinken en rijden", "Het is OK om Nee te zeggen", Verspreid onruststokers op school',
  },
  DISCOURAGE_IMITATION: {
    TITLE: 'Ontmoedig imitatie',
    DESC: "Snelle reparatie van vandalisme, V-chips in TV's, Censureer details van modus operandi",
  },
  REMOVE_EXCUSES: 'Verwijder excuses',
  SET_RULES: {
    TITLE: 'Stel regels op',
    DESC: 'Huurovereenkomsten, Intimidatiecodes, Hotelregistratie',
  },
  POST_INSTRUCTIONS: {
    TITLE: 'Plaats instructies',
    DESC: '"Parkeren verboden", "Privé-eigendom", "Doof kampvuren"',
  },
  ALERT_CONSCIENCE: {
    TITLE: 'Activeer geweten',
    DESC: 'Snelheidsweergaveborden langs de weg, Handtekeningen voor douaneaangiften, "Winkeldiefstal is stelen"',
  },
  ASSIST_COMPLIANCE: {
    TITLE: 'Help bij naleving',
    DESC: 'Eenvoudige bibliotheekuitleen, Openbare toiletten, Afvalbakken',
  },
  CONTROL_DRUGS: {
    TITLE: 'Beheers drugs en alcohol',
    DESC: "Ademanalysers in bars, Interventie programma's voor barpersoneel, Alcoholvrije evenementen",
  },
  EXPORT_TO_WORD: 'Exporteer naar Word',
  EXPORT_TO_JSON: 'Exporteer naar JSON',
  INTRODUCTION: 'Introductie',
  SEARCH: 'Zoek...',
  SEARCH_TOOLTIP: 'Type / om te zoeken',
  HITS: {
    0: 'Geen resultaten gevonden.',
    1: '1 resultaat gevonden:',
    n: '{n} resultaten gevonden:',
  },
  SYNONYMS: 'Synoniemen',
  PARENTS: 'Ouders',
  CATEGORIES: 'Categorieën',
  BELONGS_TO: 'Behoort tot',
  LOCATIONS: { 0: 'Locaties', 1: 'Locatie', n: 'Locaties' },
  PRODUCTS: { 0: 'Producten', 1: 'Product', n: 'Producten' },
  GEOLOCATIONS: { 0: 'Geolocatie', 1: 'Geolocatie', n: 'Geolocaties' },
  TRANSPORT: 'Transportmiddel',
  TRANSPORTS: 'Transportmiddelen',
  I18n: {
    editRepeat: 'Bewerk item',
    createRepeat: 'Maak een nieuw item',
    deleteItem: 'Verwijder een item',
    agree: 'Ja',
    disagree: 'Nee',
    pickOne: 'Kies één',
    pickOneOrMore: 'Kies één of meer',
    cancel: 'Opheffen',
    save: 'Bewaren',
  },
  OTHER: 'Overig',
  TEXT: 'Tekst',
  OPPORTUNITY: 'Gelegenheid',
  OPPORTUNITIES: 'Gelegenheden',
  PARTNER: 'Partner',
  PARTNERS: 'Partners',
  INDICATOR: 'Indicator',
  INDICATORS: 'Indicatoren',
  SERVICE_PROVIDER: 'Dienstverlener',
  SERVICE_PROVIDERS: 'Dienstverleners',
  STEPS: 'Stappen',
  HEADER: 'Titel',
  IS_GENERIC: 'Generieke scène',
  FOUND_ITEMS: 'Aangetroffen zaken',
  SORT_BY: 'Sorteer o.b.v.',
  FILTER: { label: 'Filter', ph: 'Druk op enter om te filteren' },
  PUBLISHED_AT: 'Publicatiedatum',
  CREATED: 'Datum aangemaakt',
  READ_ORIGINAL: 'Lees het originele artikel',
};
